/* External dependencies */
import { concat, from } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { Order } from '../../../shared/types';
import { listOrders } from '../../list-orders/redux/actions';
import { updateOrderError, updateOrderSuccess } from './action';
import { updateOrderMutation } from './mutation';
import { UpdateOrderActionTypes, UpdateOrderInput, UpdateOrderRequest } from './types';

export default function updateOrderEpic(action$, state$) {
  return action$.pipe(
    filter((action: UpdateOrderRequest) => action.type === UpdateOrderActionTypes.UPDATE_ORDER_REQUEST),
    switchMap((action: UpdateOrderRequest) =>
      from(updateOrder(action.input)).pipe(
        switchMap((order) => {
          const currentState = state$.value;
          const { query, filter, size, currentPage } = currentState.listOrders;

          return concat(
            from([updateOrderSuccess(order)]),
            from([listOrders({ query, filter, size, currentPage: currentPage })]),
          );
        }),
        catchError((error) => from([updateOrderError(error)])),
      ),
    ),
  );
}

export async function updateOrder(input: UpdateOrderInput): Promise<Order> {
  const graphQLClient = await getClient();

  const mutation = { mutation: updateOrderMutation, variables: { input } };

  const {
    data: { updateOrder },
  } = await graphQLClient.mutate(mutation);

  return updateOrder;
}
